import RoutingService from 'services/RoutingService';

export const useMainProjectUrl = () => {
  let mainProjectUrl = RoutingService.getMainProjectFromUrl();

  return mainProjectUrl
}